import {
  ApiAccessCompanySize,
  ApiAccessIndustrySector,
  ApiAccessMonthlyCallVolume,
  ApiAccessPlatformStatus,
  ApiAccessUseCase,
} from "__generated__/graphql";
import { z } from "zod";

const optionalUrl = z
  .string()
  .trim()
  .optional()
  .or(z.literal(""))
  .refine((value) => !value || /^https?:\/\/.+/i.test(value), {
    message: "Enter a valid URL starting with http:// or https://",
  })
  .transform((value) => value || undefined);

const optionalText = () =>
  z
    .string()
    .trim()
    .optional()
    .or(z.literal(""))
    .transform((value) => value || undefined);

export const apiAccessRequestSchema = z.object({
  companyName: z.string().trim().min(1, "Company name is required"),
  companyWebsite: optionalUrl,
  industrySector: z.nativeEnum(ApiAccessIndustrySector, {
    errorMap: () => ({ message: "Industry / sector is required" }),
  }),
  companySize: z.nativeEnum(ApiAccessCompanySize, {
    errorMap: () => ({ message: "Company size is required" }),
  }),
  fullName: z.string().trim().min(1, "Full name is required"),
  jobTitleOrRole: z.string().trim().min(1, "Job title / role is required"),
  workEmail: z.string().trim().email("Enter a valid work email"),
  phoneNumber: optionalText(),
  useCases: z
    .array(z.nativeEnum(ApiAccessUseCase))
    .min(1, "Select at least one API use case"),
  existingPlatformStatus: z.nativeEnum(ApiAccessPlatformStatus, {
    errorMap: () => ({
      message: "Select whether you have an existing platform to integrate with",
    }),
  }),
  estimatedMonthlyApiCalls: z
    .nativeEnum(ApiAccessMonthlyCallVolume)
    .optional()
    .or(z.literal(""))
    .transform((value) => value || undefined),
  integrationDescription: optionalText(),
});

export type ApiAccessRequestFormData = z.infer<typeof apiAccessRequestSchema>;
